module.exports = __webpack_public_path__ + "static/media/gathering.ec2aef55.jpg";